import { combineReducers } from 'redux'
import { userReducer } from './userReducer'
import { notificationReducer } from './notificationReducer'
import { messagesReducer } from './messagesReducer'

export default combineReducers({
    userReducer,
    notificationReducer,
    messagesReducer
})